import {
  FunctionMatrixRow,
  Tariff,
  TariffFunctionMatrix,
} from "../../services/subscriptionService/subscriptionService.types";

export interface VisibleTariffFunction {
  id: number;
  name: string;
  flags: boolean[];
}

export const formatMoney = (value: string | number): string =>
  `${new Intl.NumberFormat("ru-RU").format(Number(value))} руб.`;

export const periodLabel = (days: number): string => {
  if (days >= 360) return "год";
  if (days >= 175) return "полгода";
  if (days >= 85) return "квартал";
  if (days >= 28 && days <= 31) return "мес";
  if (days === 7) return "неделю";
  return `${days} дн.`;
};

export const formatDate = (value: string): string => {
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("ru-RU").format(date);
};

export const daysRemaining = (endDate: string, now = new Date()): number => {
  const end = new Date(endDate).getTime();
  if (Number.isNaN(end)) return 0;
  return Math.max(0, Math.ceil((end - now.getTime()) / 86_400_000));
};

export const orderTariffs = (tariffs: Tariff[]): Tariff[] => {
  const current = tariffs.find((tariff) => tariff.is_active);
  if (!current) return tariffs;
  return [current, ...tariffs.filter((tariff) => tariff.id !== current.id)];
};

const flagsForTariffOrder = (
  row: FunctionMatrixRow,
  matrix: TariffFunctionMatrix,
  tariffs: Tariff[],
): boolean[] => {
  const flagByTariff = new Map<number, boolean>();
  matrix.tariffs.forEach((tariff, index) => {
    flagByTariff.set(tariff.id, Boolean(row.flags[index]));
  });
  return tariffs.map((tariff) => flagByTariff.get(tariff.id) ?? false);
};

export const visibleTariffFunctions = (
  matrix: TariffFunctionMatrix,
  tariffs: Tariff[],
  onlyDifferences: boolean,
): VisibleTariffFunction[] =>
  matrix.functions
    .map((row) => ({
      id: row.id,
      name: row.name,
      flags: flagsForTariffOrder(row, matrix, tariffs),
    }))
    .filter((row) => !onlyDifferences || new Set(row.flags).size > 1);
